import { Box, Typography } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import useAPI from "../../../../api/hooks/useAPI";
import useColors from "../../../../api/hooks/useColors";
import { ReactComponent as LinkLeftIcon } from "../../../../icons/icon_files/Direction_link_left_16.svg";
import SvgToIcon from "../../../../icons/SvgToIcon";
import { QueryParam } from "../../../../utils/constants";

export default function EntityTypeBackButton() {
  const colors = useColors();
  const { trackEvent } = useAPI();
  const [searchParams, setSearchParams] = useSearchParams();

  const handleBackButtonClick = () => {
    searchParams.delete(QueryParam.environmentType);
    setSearchParams(searchParams);
    trackEvent("User clicked the back button to the entities overview page");
  };

  return (
    <Box
      height="24px"
      width="max-content"
      display="flex"
      alignItems="center"
      onClick={handleBackButtonClick}
      sx={{ cursor: "pointer" }}
    >
      <SvgToIcon IconLogo={LinkLeftIcon} width="18px" />
      <Typography variant="overline" color={colors.grey_700}>
        Back to Overview
      </Typography>
    </Box>
  );
}
